// extracted by mini-css-extract-plugin
export default {"telephonePicker":"styles_telephonePicker__LljWs"};